module.exports = __webpack_public_path__ + "img/happy-family-dentist.4e85284b.jpeg";